<template>
	<div class="cart grid-container">
		<div class="grid-x grid-margin-y grid-margin-x">
			<!-- Headings -->
			<div class="cell small-12 medium-12 large-8">
				<span>{{ $t('cart.preTitle') }}</span>
				<h1>{{ $t('cart.cartTitle') }}</h1>
			</div>

			<!-- Login/Create account CTAs -->
			<!-- <div
				v-if="isLoggedIn()"
				class="cell small-12 medium-12 large-4 grid-x cart__options"
			>
				<div class="cell small-6">
					<router-link :to="{ name: 'profile' }">
						<Button size="small" v-bind:full="true">
							{{ $t('cart.myProfile') }}
						</Button>
					</router-link>
				</div>
				<div class="cell small-5 medium-5 small-offset-1">
					<router-link :to="{ name: 'search' }">
						<Button color="dark" size="small" v-bind:full="true">
							{{ $t('cart.goToSearch') }}
						</Button>
					</router-link>
				</div>
			</div> -->
			<div
				v-if="!isLoggedIn()"
				class="cell small-12 medium-12 large-4 grid-x cart__options"
			>
				<div class="cell small-6">
					<Button
						size="small"
						v-bind:full="true"
						@click.native="showLoginModal"
					>
						{{ $t('cart.login') }}
					</Button>
				</div>
				<div class="cell small-5 medium-5 small-offset-1">
					<router-link :to="{ name: 'newaccount' }">
						<Button color="dark" size="small" v-bind:full="true">
							{{ $t('cart.createAccount') }}
						</Button>
					</router-link>
				</div>
			</div>

			<div class="cell small-12 medium-12 large-8">
				<!-- Accomodations -->
				<Accordion
					v-on:toggle="
						toggleAccordion({
							showAccommodation: !cart.accordion.showAccommodation
						})
					"
					:title="$t('accommodation.accommodation')"
					:titleParanthesis="cart.accommodation.length.toString()"
					v-bind:show="cart.accordion.showAccommodation"
					iconType="accommodation"
					:large="true"
				>
					<CartList v-if="cart.accommodation.length">
						<CartAccommodation />
					</CartList>

					<div v-else class="cart__empty-section">
						<p v-html="$t('cart.noAccommodationText')"></p>
						<router-link :to="{ name: 'search' }">
							<Button size="small">
								{{ $t('cart.addAccommodation') }}
							</Button>
						</router-link>
					</div>
				</Accordion>

				<!-- Skipass -->
				<Accordion
					v-on:toggle="
						toggleAccordion({ showSkipass: !cart.accordion.showSkipass })
					"
					:title="$t('skipass.skipass')"
					v-bind:show="cart.accordion.showSkipass"
					iconType="skipass"
					:large="true"
					:titleParanthesis="cart.skipass.length.toString()"
					:errorSum="skipassErrors"
				>
					<CartList v-if="cart.skipass.length">
						<CartSkipass />
					</CartList>

					<div v-else class="cart__empty-section">
						<p v-html="$t('cart.noSkipassText')"></p>
						<router-link :to="{ name: 'skipass' }">
							<Button size="small">
								{{ $t('cart.addSkipass') }}
							</Button>
						</router-link>
					</div>
				</Accordion>

				<!-- Skirental -->
				<Accordion
					v-on:toggle="
						toggleAccordion({ showSkirental: !cart.accordion.showSkirental })
					"
					:title="$t('skirental.skirental')"
					v-bind:show="cart.accordion.showSkirental"
					iconType="skirental"
					:large="true"
					:titleParanthesis="cart.skirental.length.toString()"
					:errorSum="skirentalErrors"
				>
					<CartList v-if="cart.skirental.length">
						<CartSkirental />
					</CartList>

					<div v-else class="cart__empty-section">
						<p v-html="$t('cart.noSkirentalText')"></p>
						<router-link :to="{ name: 'skirental' }">
							<Button size="small">
								{{ $t('cart.addSkirental') }}
							</Button>
						</router-link>
					</div>
				</Accordion>

				<!-- Skischool -->
				<Accordion
					v-on:toggle="
						toggleAccordion({ showSkischool: !cart.accordion.showSkischool })
					"
					:title="$t('skischool.skischool')"
					v-bind:show="cart.accordion.showSkischool"
					iconType="skischool"
					:large="true"
					:titleParanthesis="cart.skischool.length.toString()"
					:errorSum="skischoolErrors"
				>
					<CartList v-if="cart.skischool.length">
						<CartSkischool />
					</CartList>

					<div v-else class="cart__empty-section">
						<p v-html="$t('cart.noSkischoolText')"></p>
						<router-link :to="{ name: 'skischool' }">
							<Button size="small">
								{{ $t('cart.addSkischool') }}
							</Button>
						</router-link>
					</div>
				</Accordion>

				<!-- Activities -->
				<Accordion
					v-on:toggle="
						toggleAccordion({ showActivities: !cart.accordion.showActivities })
					"
					:title="$t('activities.activities')"
					v-bind:show="cart.accordion.showActivities"
					iconType="activities"
					:large="true"
					:titleParanthesis="cart.activities.length.toString()"
					:errorSum="activitiesErrors"
				>
					<CartList v-if="cart.activities.length">
						<CartActivities />
					</CartList>

					<div v-else class="cart__empty-section">
						<p v-html="$t('cart.noActivitiesText')"></p>
						<router-link :to="{ name: 'activities' }">
							<Button size="small">
								{{ $t('cart.addActivities') }}
							</Button>
						</router-link>
					</div>
				</Accordion>
			</div>

			<!-- Cart summary -->
			<div class="cell small-12 medium-12 large-4">
				<CartOverview @open-accordion="toggleAccordion" />
			</div>
		</div>

		<!-- Error modal - accommodation availability -->
		<Modal
			v-if="globalModals.showAccommodationNotAvailable == true"
			@close="closeModale('showAccommodationNotAvailable')"
		>
			<h4>{{ $t('cart.bookingFailedTitle') }}</h4>
			<br />
			<p>{{ $t('cart.bookingFailedBody') }}</p>
		</Modal>

		<!-- Error modal - out of date products -->
		<Modal
			v-if="globalModals.showOutOfDateCartModal == true"
			@close="closeModale('showOutOfDateCartModal')"
			:disableClose="true"
			:maxWidth="300"
			alignment="center"
			class="cart__error-modal"
		>
			<h4>{{ $t('cart.removedProductsTitle') }}</h4>
			<p v-html="$t('cart.removedProductsBody')"></p>
			<Button @click.native="closeModale('showOutOfDateCartModal')">
				{{ $t('cart.removedProductsButton') }}
			</Button>
		</Modal>

		<!-- Error modal - checkout failed -->
		<Modal
			v-if="globalModals.showCheckoutErrorModal == true"
			@close="closeModale('showCheckoutErrorModal')"
			:disableClose="true"
			:maxWidth="300"
			alignment="center"
			class="cart__error-modal"
		>
			<h4>{{ $t('cart.checkoutFailedTitle') }}</h4>
			<p v-html="$t('cart.checkoutFailedBody')"></p>
			<Button @click.native="closeModale('showCheckoutErrorModal')">
				{{ $t('cart.checkoutFailedButton') }}
			</Button>
		</Modal>
	</div>
</template>

<script>
import store from '../vueX/store'
import Button from '../components/atoms/Button'
import Modal from '../components/molecules/Modal'
import CartList from '../components/molecules/CartList'
import Accordion from '../components/molecules/Accordion.vue'
import CartOverview from '../components/molecules/CartOverview.vue'
import CartAccommodation from '../components/molecules/CartAccommodation'
import CartSkipass from '../components/molecules/CartSkipass'
import CartSkirental from '../components/molecules/CartSkirental'
import CartSkischool from '../components/molecules/CartSkischool'
import CartActivities from '../components/molecules/CartActivities'

export default {
	name: 'Cart',
	store,
	components: {
		Button,
		Modal,
		CartList,
		CartOverview,
		Accordion,
		CartAccommodation,
		CartSkipass,
		CartSkirental,
		CartSkischool,
		CartActivities
	},
	computed: {
		cart() {
			return store.state.cart
		},
		skipassErrors() {
			if (this.cart.cartCheckoutClicked) {
				return store.state.cart.skipass.filter(each => {
					// Check if all is true
					return !Object.keys(each.guestValidation).every(
						k => each.guestValidation[k]
					)
				}).length
			} else {
				return 0
			}
		},
		skirentalErrors() {
			if (this.cart.cartCheckoutClicked) {
				return store.state.cart.skirental.filter(each => {
					// Check if all is true
					return !Object.keys(each.guestValidation).every(
						k => each.guestValidation[k]
					)
				}).length
			} else {
				return 0
			}
		},
		skischoolErrors() {
			if (this.cart.cartCheckoutClicked) {
				return store.state.cart.skischool.filter(each => {
					// Check if all is true
					return !Object.keys(each.guestValidation).every(
						k => each.guestValidation[k]
					)
				}).length
			} else {
				return 0
			}
		},
		activitiesErrors() {
			if (this.cart.cartCheckoutClicked) {
				return store.state.cart.activities.filter(each => {
					// Check if all is true
					return !Object.keys(each.guestValidation).every(
						k => each.guestValidation[k]
					)
				}).length
			} else {
				return 0
			}
		},
		globalModals() {
			return store.state.globalModals
		}
	},
	data() {
		return {
			userLoggedIn: false,
			showAccommodationErrorModal: false,
			showCheckoutErrorModal: false,
			showAccommodation: false,
			showSkirental: false,
			showSkischool: false,
			showSkipass: false,
			showActivities: false
		}
	},
	methods: {
		closeModale(type) {
			store.commit('TOGGLE_GLOBAL_MODAL', { [type]: false })
		},
		showLoginModal() {
			store.dispatch('TOGGLE_GLOBAL_MODAL', { showLoginForm: true })
		},
		isLoggedIn() {
			return store.state.user != null
		},
		toggleAccordion(type) {
			store.dispatch('TOGGLE_CART_ACCORDION', type)
		},
		removeProduct(id, type) {
			const actionName = 'REMOVE_CART_' + type.toUpperCase()

			store
				.dispatch(actionName, {
					uniqueId: id
				})
				.then(() => {
					store.dispatch('TOGGLE_GLOBAL_MODAL', {
						showOutOfDateCartModal: true
					})

					if (store.state.cart.cartCheckoutClicked) {
						store.dispatch('VALIDATE_PRODUCTS_IN_CART')
					}
				})
		}
	},
	created() {
		// Remove out-of-date products

		function addDays(date, days) {
			const dateCopy = new Date(date)
			dateCopy.setDate(date.getDate() + days)
			return dateCopy
		}

		//Skipass - bookable same day (remove 1 day after begindate)
		store.state.cart.skipass.forEach(each => {
			const today = new Date()
			today.setHours(0, 0, 0, 0)

			const prodDate = new Date(each.begindate)
			prodDate.setHours(0, 0, 0, 0)

			if (prodDate < today) {
				this.removeProduct(each.uniqueId, 'skipass')
			}
		})

		//Skirental - bookable up until 3 days ahead (remove when less than 3 days before startDate)
		store.state.cart.skirental.forEach(each => {
			const prodDate = new Date(each.startDate)
			prodDate.setHours(0, 0, 0, 0)

			const bookableDate = addDays(new Date(), 3)
			bookableDate.setHours(0, 0, 0, 0)

			if (prodDate < bookableDate) {
				this.removeProduct(each.uniqueId, 'skirental')
			}
		})

		//Set fast/normal checkout
		store.dispatch('SET_CHECKOUT_TYPE')
	}
}
</script>

<style scoped lang="scss">
$padding-small: 20px;
%cart-border {
	margin-bottom: $padding-small;
	padding-bottom: 10px;
	border-bottom: $pale-blue-border;
}

.cart {
	.accommodationcard__addon:last-child {
		background-color: black;
	}
	margin-top: $spacing5;
	padding: 0 $spacing4;
	span {
		color: $colorPrimary7;
		font-size: 14px;
		line-height: 20px;
	}
	.heading {
		color: $colorPrimary;
		font-size: 20px;
		font-weight: 500;
		letter-spacing: 0;
		line-height: 32px;
		&--large {
			font-size: 24px;
			line-height: 30px;
		}
	}
	&__main {
		margin-top: 20px;
		border-bottom: 1px solid #7f8ba1;
	}
	&__main-price {
		color: $colorPrimary;
	}
	&__main-total {
		text-align: right;
	}
	&__addon-title {
		color: $colorPrimary;
		font-size: 15px;
		font-weight: 500;
		letter-spacing: 0;
		line-height: 24px;
	}
	&__price {
		text-align: right;
	}
	&__title {
		border-top: $pale-blue-border;
		margin-top: 0;
		padding-top: $padding-small;
	}
	&__options {
		align-self: flex-end;
		@include for-phone-only {
			margin-top: 0;
		}
	}
	&__total {
		background-color: #f7f8f9;
		padding: $padding-small;
	}
	&__total-title {
		@extend %cart-border;
		text-align: left;
	}
	&__total-acc {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	&__total-price {
		border-top: $pale-blue-border;
		margin: $padding-small 0;
		padding-top: $padding-small;
	}
	&__image {
		width: 100%;
		margin-top: 40px;
	}

	&__item {
		position: relative;
		display: block;

		&:hover,
		&:focus {
			text-decoration: none;
		}

		.icon {
			width: 24px;
			height: 24px;
			position: absolute;
			top: $spacing3;
			right: 0;

			&-pen,
			&-add {
				fill: $colorSecondary;
			}

			&-add {
				width: 30px;
				height: 30px;
			}
		}

		/*&:last-child {
      border-bottom: $pale-blue-border;
    }*/

		h4 {
			//color: $colorSecondary;
			margin-bottom: $padding-small/2;
		}

		+ .cart__total {
			border-top: $pale-blue-border;
			padding-top: $spacing5;
		}
	}

	&__buttons {
		position: absolute;
		top: -$padding-small - 20;
		right: $padding-small;
		button:first-child {
			margin-right: $padding-small;
		}
		@include for-tablet-landscape-up {
			top: -$padding-small;
		}
	}

	&__accommodations {
		padding: $padding-small $padding-small * 2;
		background-color: #f7f8f9;
		margin-bottom: $padding-small * 2;
		position: relative;
		@include for-tablet-landscape-up {
			margin-bottom: 60px;
		}

		@include for-phone-only {
			padding: $padding-small;
		}
	}
	&__accommodation-price {
		text-align: right;
		h4 {
			margin-top: $padding-small;
			padding-top: 10px;
			border-top: $pale-blue-border;
		}
	}
	&__payment-info {
		padding: 10px;
		text-align: left;
	}

	&__empty-section {
		margin-top: -20px;
		margin-left: 65px;
		margin-bottom: 30px;
		@include for-tablet-portrait-up {
			margin-left: 72px;
		}
		@include for-desktop-up {
			margin-left: 92px;
		}
		p {
			margin-top: 20px;
			margin-bottom: 25px;
		}
	}

	&__error-modal {
		h4 {
			margin-bottom: 15px;
		}
		p {
			text-align: left;
		}
		button {
			margin-top: 20px;
		}
	}

	.cart-details-wrapper {
		margin-top: $spacing2;

		> * {
			margin-top: $padding-small;

			&:first-child {
				margin-top: 0;
			}
		}
	}

	.cart-details-columns {
		display: flex;
		@extend %cart-border;

		&:first-child {
			margin-top: 0;
		}

		+ p {
			margin-top: 10px;
		}

		> * {
			flex-basis: 50%;
			margin-top: 10px;

			&:last-child {
				text-align: right;
			}
		}
	}

	p + .cart-details-columns {
		margin-top: 5px;
	}

	.cart-details__column > * {
		margin-top: 10px;

		&:first-child {
			margin-top: 0;
		}
	}

	.last-cart-item .cart__item__spec {
		border-bottom: $pale-blue-border;
	}

	.cart__total {
		text-align: right;
	}
}
</style>
